import baseUrl from "../Api/baseUrl";
import notify from "./useNotifaction";

export const useGetData = async (url, params = {}) => {
  try {
    const config = {
      headers: {
        token: `${localStorage.getItem("token")}`,
      },
      params,
    };
    const res = await baseUrl.get(url, config);
    console.log(res)
    return res.data;
  } catch (err) {
    console.error("Error in useGetData:", err.response || err.message);
    throw err;
  }
};

export const useGetDataToken = async (url, params) => {
  const config = {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
  const res = await baseUrl.get(url, params, config);
  return res.data;
};
